export default __webpack_public_path__ + "static/ptr-dbb792a3be4e0388982d46bce0ed497f.jpg";